



































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { ILoginFields } from '@/common/types';

import axios from 'axios';

// Components
import Alert from '@/components/Global/Alert.vue';
import NewRegistrationFlowBase from '@/components/Login/NewRegistrationFlowBase.vue';
import Welcome from '@/components/Global/Welcome.vue';
import Loading from '@/components/Global/Loading.vue';
import Validation from '@/components/Form/Validation.vue';
import TextField from '@/components/Form/TextField.vue';

// Services
import Brand from '@/services/Brand';
import AuthService from '@/services/Auth';
import Staff from '@/services/Staff';

// Validator
import { required, email, minLength } from 'vuelidate/lib/validators';
import { hasUppercase, hasLowercase, hasNumber, hasSpecialCharacter } from '@/validations';

// Store and Router
import store from '@/store';
import router from '@/router';

@Component({
	name: 'SignInRegister',
	components: {
		Alert,
		NewRegistrationFlowBase,
		Loading,
		TextField,
		Validation,
		Welcome,
	},
	validations: {
		form: {
			email: {
				email,
				required,
			},
			password: {
				required,
				minLength: minLength(10),
				hasUppercase,
				hasLowercase,
				hasNumber,
				hasSpecialCharacter,
			},
		},
	},
})
export default class SignInRegister extends Vue {
	@Prop(String) private authOptions: any;
	private Brand: any;
	private autoSignout: boolean;
	private loading: boolean;
	private user: {
		username: null | string;
	};
	private error: string | boolean;
	private isInvalid: boolean;
	private form: ILoginFields;
	private changePassword: boolean;
	private signInDisabled: boolean;
	private invite: any;
	private guestPaymentUrl: string;
	constructor() {
		super();

		this.Brand = Brand;
		this.autoSignout = false;
		this.loading = false;
		this.user = {
			username: null,
		};
		this.error = '';
		this.isInvalid = false;
		this.form = {
			email: '',
			password: '',
		};
		this.changePassword = window.changePassword;
		this.signInDisabled = true;
		this.invite = null;
		this.guestPaymentUrl = process.env.VUE_APP_MYACCOUNT_URL + 'guest-payment';
	}

	get details() {
		return Brand.getBrandInformation();
	}
	private async created() {
		this.autoSignout = window.newUserRegistered;
		window.newUserRegistered = false;

		if (Brand.getBrand() === 'insurecareteams' && this.$route.name === 'brokerage') {
			this.$store.dispatch('Auth/setBrokerageId', this.$route.params.pathMatch);
			window.localStorage.setItem('brokerageId', this.$route.params.pathMatch);
		}
	}
	private routeToForgotPassword() {
		this.$router.push({
			name: 'forgot-password',
		});
	}
	private async goToRegister() {
		this.$router.push({
			name: 'quick-questions',
		});
	}
	private isInValid() {
		return this.$v.$invalid;
	}
	private async signIn(event) {
		this.form.email = this.form.email.toLowerCase();
		this.loading = true;

		this.$Amplify.Auth.configure({
			authenticationFlowType: 'CUSTOM_AUTH',
		});

		// if (this.$v.$invalid) {
		// 	this.isInvalid = true;
		// 	this.loading = false;
		// 	return;
		// }

		try {
			const signIn = await this.$Amplify.Auth.signIn(this.form.email, this.form.password);

			let mfaPreference = '';

			if (signIn && signIn.challengeParam) {
				if (signIn.challengeParam.question.indexOf(this.form.email) > 0) {
					mfaPreference = 'Email';
				} else {
					mfaPreference = 'SMS';
				}
			}
			let phoneNum = '';
			if (signIn && signIn.challengeParam && signIn.challengeParam.question.match(/(\d+)/)) {
				phoneNum = signIn.challengeParam.question.match(/(\d+)/)[0];
				const maskString = phoneNum.substring(0, 9);
				phoneNum = phoneNum.replace(maskString, '+1(xxx)xxx-xx');
			}

			if (signIn.challengeName !== undefined) {
				switch (signIn.challengeName) {
					case 'CUSTOM_CHALLENGE':
						this.$router.push({
							name: 'confirm-signin',
							params: {
								authenticationDetails: signIn,
								email: this.form.email,
								password: this.form.password,
								phone_number: phoneNum,
								mfaPreference,
							},
						});
						break;

					case 'NEW_PASSWORD_REQUIRED':
						this.$router.push({
							name: 'ChangePassword',
							params: {
								authenticationDetails: signIn,
								email: this.form.email,
								password: this.form.password,
							},
						});
						break;
				}
			} else {
				await this.signedIn();
			}
		} catch (e) {
			this.error = e.message || e;
		} finally {
			this.loading = false;
		}
	}

	private async signedIn() {
		this.loading = true;
		this.$store.dispatch('Misc/setLoading', false);
		const session = await this.$Amplify.Auth.currentSession();

		this.$store.dispatch('Auth/authenticated').then(
			async response => {
				try {
					await AuthService.redirectToUrl();
				} catch (e) {
					router.push({
						name: 'home',
					});
				}
			},
			error => {
				router.push({
					name: 'login',

					params: {
						error: true,
					},
				});
			},
		);
	}
}
